import { render } from "./NewLoanCalculatorInput.vue?vue&type=template&id=f60bd4f4"
import script from "./NewLoanCalculatorInput.vue?vue&type=script&lang=js"
export * from "./NewLoanCalculatorInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__